export default __webpack_public_path__ + "static/media/edward.9d059f32.png";